class EditorPopup {
  constructor() {
    this.popupDiv = document.querySelector('[data-editor-popup]');
    this.popupPanel = this.popupDiv.querySelector('.editor-panel');
    this.editorFrame = this.popupDiv.querySelector('iframe');
    this.launchButtons = document.querySelectorAll('.js-launch-editor');
    this.closeButton = document.querySelector('[data-close-editor]');
    this.uidInput = document.querySelector('[name="properties[_instanceUid]"]');
    this.editorKeyInput = document.querySelector('[name="properties[_editorKey]"]');
    this.recipientNameInput = document.querySelector('[name="properties[For]"]');
    this.instanceUid = null;
    this.productId = this.editorFrame.dataset.productId;
    this.preloader = document.querySelector('.editor-panel .preloader');
    this.productData = JSON.parse(document.getElementById("productData").textContent);

    const params = new URL(document.location).searchParams;
    if (params.has('uid') && params.has('k')) {
      this.instanceUid = this.uidInput.value = params.get('uid');
      this.editorKeyInput.value = params.get('k');
      this.editorFrame.src = this.editorFrame.dataset.existingUrl.replace('{uid}', this.instanceUid).replace('{key}', params.get('k'));
      this.preloader.style.display = "none";
    }
    
    /*const existingInstance = document.cookie.match(new RegExp('ecard_' + this.productId + '_uid=([^;]+)'));
    if (existingInstance) {
      console.log('Found a cookie, setting existing instance');
      let parts = existingInstance[1].split('/');
      this.instanceUid = parts[0];
      this.editorFrame.src = this.editorFrame.dataset.existingUrl.replace('{uid}', this.instanceUid).replace('{key}', parts[1]);
      this.uidInput.value = this.instanceUid;
      this.editorKeyInput.value = parts[1];
    }*/

    // Add the CSS
    const link = document.createElement('link');
    link.rel = "stylesheet";
    link.href = "//thumble.games/cdn/shop/t/25/assets/editor-popup.css?v=178703463851712717581779283979";
    document.head.appendChild(link);

    for (var launchButton of this.launchButtons) {
      launchButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.show();
      });
    }
    /*this.closeButton.addEventListener('click', (event) => {
      this.close();
      return false;
    });*/

    window.addEventListener('message', (event) => {
      console.log('Got postmessage ', event.data);
      if (event.data.action == 'editorLoaded') {
        this.preloader.style.display = "none";
      }

      if (event.data.action == 'getParentHost') {
        event.source.postMessage({action: 'setParentHost', host: window.location.hostname}, '*');
      }

      if (event.data.action == 'buy') {
        // Get the latest info form the editor
        this.uidInput.value = event.data.uid;
        this.editorKeyInput.value = event.data.editorKey;
        this.recipientNameInput.value = event.data.recipientName;

        // Check the current cart and see if the item already exists
        fetch (window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then((response) => {
            //console.log(response);

            const existing = response.items.find((i) => i.properties._editorKey == this.editorKeyInput.value);

            if (existing) {
              // Update the existing item
              fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: existing.key,
                  properties: {
                    ...existing.properties,
                    'For':  this.recipientNameInput.value,
                  },
                  title: 'Custom Runner for ' + this.recipientNameInput.value,
                  varient_title: 'Custom Runner for ' + this.recipientNameInput.value,
                })
              }).then(response => response.json())
                .then(response => {
                  //console.log(response);
                  
                  // redirect to the cart
                  window.location.href = window.Shopify.routes.root + 'cart';
                });

            } else {
              if (typeof gtag != "undefined") {
                gtag('event', 'add_to_cart', {
                  items: [this.productData]
                });
              };
              
              setTimeout(() => this.uidInput.form.submit(), 30);
            }
          });

        

        // Clear the cookie
        //console.log('Clearing cookie for ' + this.productId);
        //document.cookie = 'ecard_' + this.productId + '_uid=; expires=' + (new Date()).toUTCString() + '; path=/;';

        // Submit the product form
        //
      }

      if (event.data.action == 'exitEditor') {
        this.close();
      }
    });
  }
  
  show() {
    this.popupDiv.style.display = null;
    this.popupDiv.classList.add('fade-in-visible');
    this.popupDiv.classList.remove('fade-in-hidden');

    console.log('Adding visible class');
    this.popupPanel.classList.add('fade-in-visible');
    
    console.log('SHOW');
    if (!this.instanceUid) {
      console.log('No existing instance, creating new one.');
      fetch(this.editorFrame.dataset.newUrl, {headers: {Accept: 'application/json'}})
        .then(result => result.json())
        .then(result => {
          if (result.success) {
            this.editorFrame.src = result.url;
            this.uidInput.value = this.instanceUid = result.uid;
            this.editorKeyInput.value = result.key;
            //document.cookie = 'ecard_' + this.productId + '_uid=' + result.uid + '/' + result.key + '; path=/;'; 
          }
        });
    }

    if (typeof gtag != "undefined") {
      gtag("event", "create_game", {type: this.productData.item_name})
    }
    
    document.body.classList.add('editor-popup-open');
  }  

  close() {
    console.log('CLOSE');
    this.popupPanel.classList.remove('fade-in-visible');
    this.popupDiv.classList.remove('fade-in-visible');
    setTimeout(() => {
      this.popupDiv.classList.add('fade-in-hidden');
      document.body.classList.remove('editor-popup-open');
    }, 400)
  }
}

window.editorPopup = new EditorPopup();